import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setSubmitMessage('Моля, въведете имейл');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d6g4nr9ghdq4qda701p0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setSubmitMessage('Благодарим за абонамента!');
        setEmail('');
      } else {
        setSubmitMessage('Възникна грешка. Опитайте по-късно.');
      }
    } catch (error) {
      setSubmitMessage('Възникна грешка. Опитайте по-късно.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-[#050B14] py-16 lg:py-20">
      {/* Background text */}
      <div className="absolute inset-0 flex items-center justify-center overflow-hidden pointer-events-none">
        <div className="text-[#1F2937] opacity-[0.03] text-8xl lg:text-9xl font-black whitespace-nowrap font-['Playfair_Display']">
          FINANCIAL EXPERT
        </div>
      </div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Column 1 - Brand */}
          <div>
            <h3 className="text-3xl font-bold text-white mb-4 font-['Playfair_Display']">
              Илиев Николай
            </h3>
            <div className="w-16 h-0.5 bg-[#D4AF37] mb-4" />
            <p className="text-base text-[#9CA3AF] font-['Inter']">
              Професионално управление на капитал
            </p>
          </div>

          {/* Column 2 - Navigation */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-6 font-['Inter']">
              Навигация
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'За специалиста', id: 'about' },
                { label: 'Компетенции', id: 'competencies' },
                { label: 'Образование', id: 'education' },
                { label: 'Контакти', id: 'cta' },
              ].map((item, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className="text-sm text-[#9CA3AF] hover:text-[#D4AF37] transition-colors cursor-pointer font-['Inter']"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 - Social */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-6 font-['Inter']">
              Социални мрежи
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="https://t.me/NikLiev"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-sm text-[#9CA3AF] hover:text-[#D4AF37] transition-colors cursor-pointer group font-['Inter']"
                >
                  <i className="ri-telegram-line text-xl text-[#D4AF37] group-hover:scale-110 transition-transform"></i>
                  Telegram
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4 - Newsletter */}
          <div>
            <h4 className="text-base text-white mb-2 font-['Inter']">
              Абонирайте се за новини
            </h4>
            <p className="text-sm text-[#9CA3AF] mb-4 font-['Inter']">
              Получавайте анализи за пазарите
            </p>
            <form onSubmit={handleSubmit} className="flex gap-2" data-readdy-form id="newsletter-form">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Вашият имейл"
                className="flex-1 px-4 py-2 bg-transparent border border-[#D4AF37] rounded-full text-white text-sm placeholder-[#6B7280] focus:outline-none focus:border-[#D4AF37]/80 font-['Inter']"
                disabled={isSubmitting}
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-10 h-10 bg-[#D4AF37] rounded-full flex items-center justify-center text-white hover:rotate-45 transition-transform cursor-pointer disabled:opacity-50"
                aria-label="Абонирай се"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </form>
            {submitMessage && (
              <p className={`text-sm mt-2 font-['Inter'] ${submitMessage.includes('Благодарим') ? 'text-[#D4AF37]' : 'text-red-400'}`}>
                {submitMessage}
              </p>
            )}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-[#1F2937] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-[#6B7280] font-['Inter']">
            © 2025 Илиев Николай Андреевич. Всички права запазени.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-[#6B7280] hover:text-[#D4AF37] transition-colors cursor-pointer font-['Inter']"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
